import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, provide, watch, inject } from 'vue';
import { isNavigationOpenKey } from '@/keys';
import { registerModalKey, unregisterModalKey } from '@/composables/useModals';
import useContext from '@/composables/useContext';

import PhoneHeader from './PhoneHeader.vue';
import DesktopHeader from './DesktopHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EComHeader',
  setup(__props) {

const { route } = useContext();

const isNavigationOpen = ref(false);
provide(isNavigationOpenKey, isNavigationOpen);

const registerModal = inject(registerModalKey, (key: string) => {});
const unregisterModal = inject(unregisterModalKey, (key: string) => {});

watch(
  () => route.pathname,
  () => {
    isNavigationOpen.value = false;
  }
);

watch(isNavigationOpen, (val) => {
  if (val) {
    registerModal('navigation');
  } else {
    unregisterModal('navigation');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DesktopHeader, { class: "header__desktop" }),
    _createVNode(PhoneHeader, { class: "header__phone" })
  ], 64))
}
}

})